export default __webpack_public_path__ + "static/media/About_v1.47086470.md";